const toggleFilterOnMobile = () => {
    if(document.querySelector('.kirinus-job-openings-overview-filter--mobile-button')){

        document.addEventListener('click', ev =>{
            if(!ev.target.classList.contains('kirinus-job-openings-overview-filter--mobile-button')) return;
            ev.preventDefault();
            const parent = ev.target.closest('.kirinus-job-openings-overview-filter');
            parent.classList.toggle('kirinus-job-openings-overview-filter__active');
        })
    }
}
export default toggleFilterOnMobile;